import { apiClient } from "./ApiClient";

/**
 * Stakeholder Map API Service
 * ─────────────────────────────────────────────────────────────────────────────
 * Two simple calls that back the Stakeholder Map report page:
 *
 *   getStakeholderMapStakeholdersApi()
 *     GET /stakeholder-map-view/all-stakeholders
 *     Returns a lightweight id/code/name/type list for every active stakeholder
 *     (all types: CUSTOMER, VENDOR, CONSIGNEE, SHIPPER, …).  Called once on mount
 *     to populate the stakeholder picker / autocomplete.
 *
 *   getStakeholderMapProfileApi(stakeholderId)
 *     GET /stakeholder-map-view/profile/:id
 *     Returns the full StakeholderMapDto containing the stakeholder entity plus
 *     all related data (offers, orders, samples, shipments, SIs).  Called each
 *     time the user selects a different stakeholder.
 */

/** Fetch all active stakeholders (all types) for the picker autocomplete. */
export const getStakeholderMapStakeholdersApi = () =>
  apiClient.get("/stakeholder-map-view/all-stakeholders");

/**
 * Fetch the complete Stakeholder Map profile for one counterparty.
 *
 * @param {number} stakeholderId – the stakeholder's primary key
 */
export const getStakeholderMapProfileApi = (stakeholderId) =>
  apiClient.get(`/stakeholder-map-view/profile/${stakeholderId}`);
